import styled from 'styled-components';
import { WarningBadge } from 'ui/badge';
import { colors, fontSizes, fontWeights, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

export const IntergrationsContainer = styled.section`
  margin-top: ${spacing.double};
`;

export const MobileAppList = styled.ul`
  display: grid;
  grid-gap: ${spacing.plusHalf};
  list-style: none;
  margin-bottom: 0;
  margin-top: ${spacing.double};
  padding-left: 0;

  grid-template-columns: repeat(3, 1fr);
  &[data-formview='true'] {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (width <= 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const MobileAppName = styled.div`
  margin-top: ${spacing.base};
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.s16};
  text-align: center;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PackageName = styled.div`
  color: ${colors.textSecondary};
  margin-top: ${spacing.quarter};
`;

export const StyledTooltip = styled(Tooltip)`
  position: absolute;
  top: ${spacing.threeQuarter};
  right: ${spacing.threeQuarter};
`;

export const StyledWarningBadge = styled(WarningBadge)`
  color: ${colors.textWarning};
  background-color: ${colors.backgroundWarningSubtle};
`;
